<div class="container single-view" id="add-retailer-attributes-definitions">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/retailer-attribute-definitions" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS.BTN_BACK_TO_RETAILER_ATTRIBUTE_DEFINITIONS' | translate }}</a>
      </div>
    </div>

    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-retailerattribute-create-retailerattribute-title" class="section-title">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-retailerattribute-create-retailerattribute-subtitle" class="section-subtitle mt-1 text-base">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>

      <hr role="presentation" class="w-full mb-3 mt-6 border-t">

      <div class="view-content-wr">
        <div class="row rounded-card">
          <app-attribute-definition-form
            #definitionForm
            mode="create"
            formTestId="add-retailerattribute-create-retailerattribute-form"
            (submitted)="submitForm($event)">
          </app-attribute-definition-form>
        </div>

        <div class="row">
          <div class="col-12 mt-6 mb-4 pt-8 border-t">
            <div class="flex items-center justify-end gap-3">
              <button data-testid="add-retailerattribute-create-retailerattributedefinition-button" id="btn-create-retailer-attribute-definition" class="btn primary-btn" type="button" [disabled]="definitionForm.attributeDefinitionForm.invalid" (click)="definitionForm.submitForm()">{{ 'RETAILER_ATTRIBUTES_DEFINITIONS_CREATE.BTN_SAVE_ATTRIBUTES' | translate }}</button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
